import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Option } from '../../types/form.type';
import { TaxService } from 'libs/admin/tax/src/lib/services/tax.service';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';

@Component({
  selector: 'hospitality-bot-add-refund',
  templateUrl: './add-refund.component.html',
  styleUrls: ['./add-refund.component.scss'],
})
export class AddRefundComponent implements OnInit {
  heading = 'Additional Charges Amount';
  isReservationPopup = false;
  isAllowancePopup = false;
  isTaxInclusiveVisible = true;
  userForm: FormGroup;
  chargedAmount: number = 0;
  isTaxDropdown: boolean = false;
  taxDropdownOptions: Option[] = [];
  entityId: string;
  maxAmount?: number;
  serviceName?: string;

  private readonly subscription = new Subscription();

  constructor(
    private fb: FormBuilder,
    public dialogRef: DynamicDialogRef,
    public dialogConfig: DynamicDialogConfig,
    private taxService: TaxService
  ) {
    const data: {
      heading: string;
      isReservationPopup?: boolean;
      chargedAmount?: number;
      isAllowancePopup?: boolean;
      isTaxInclusiveVisible?: boolean;
      isTaxDropdown?: boolean;
      entityId?: string;
      maxAmount?: number;
      serviceName?: string;
    } = dialogConfig?.data;
    this.heading = data?.heading;
    this.isReservationPopup = data?.isReservationPopup;
    this.chargedAmount = data?.chargedAmount;
    this.isAllowancePopup = data?.isAllowancePopup;
    this.isTaxInclusiveVisible =
      data?.isTaxInclusiveVisible ?? (data?.isReservationPopup ? false : true);
    this.isTaxDropdown = data?.isTaxDropdown ?? false;
    this.entityId = data?.entityId;
    this.maxAmount = data?.maxAmount;
    this.serviceName = data?.serviceName;

    if (this.isTaxDropdown) this.getTaxOptions();
  }

  ngOnInit(): void {
    this.initForm();
    this.listenForRefundAmountChanges();
  }

  initForm(): void {
    const refundAmountValidators = [Validators.required, Validators.min(0.01)];
    if (
      this.maxAmount !== undefined &&
      this.maxAmount !== null &&
      this.maxAmount >= 0
    ) {
      refundAmountValidators.push(Validators.max(this.maxAmount));
    }

    this.userForm = this.fb.group({
      ...(this.isReservationPopup
        ? {
            chargedAmount: [
              this.chargedAmount,
              [Validators.required, Validators.min(0)],
            ],
          }
        : { refundAmount: [null, refundAmountValidators] }),
      remarks: ['', [Validators.required]],
      inclusiveTax: [false],
      tax: [null],
    });
  }

  listenForRefundAmountChanges(): void {
    this.userForm.get('refundAmount')?.valueChanges.subscribe((value) => {
      if (value <= 0) {
        this.userForm.get('inclusiveTax')?.setValue(false);
      }
    });
  }

  handleApply(): void {
    if (this.userForm.invalid) {
      this.userForm.markAllAsTouched();
      return;
    }

    const val = this.userForm.value;
    this.dialogRef.close({
      chargedAmount: this.isReservationPopup ? val.chargedAmount : val.refundAmount,
      refundAmount: val.refundAmount,
      remarks: val.remarks,
      inclusiveTax: val.inclusiveTax,
      tax: val.tax,
    });
  }

  close(): void {
    this.dialogRef.close();
  }

  getTaxOptions(): void {
    if (!this.entityId) return;
    this.subscription.add(
      this.taxService
        .getTaxList(this.entityId, {
          params: `?status=true&limit=0&entityId=${this.entityId}`,
        })
        .subscribe((res) => {
          this.taxDropdownOptions = (res?.records || []).map((t) => ({
            label: `${t.taxType} (${t.taxValue}%)`,
            value: t.id,
          }));
        })
    );
  }
}
